import {
  ELSStorageHelper,
  ELSCommonUIConstants,
} from '@els/els-ui-common-react';
import { AppConstants } from '../components/app/app.constants';

// We store the refresh token under the appId so that we do not accidentally grab
// a refresh token from another application and try to use it to boot up this app
const refreshTokenKey = `${AppConstants.APP_ID}_refreshToken`;

export const storeRefreshToken = (refreshToken: string): void => {
  ELSStorageHelper.driver(ELSCommonUIConstants.security.Locker.DefaultDriver)
    .namespace(ELSCommonUIConstants.security.Locker.TokenNamespace)
    .put(refreshTokenKey, refreshToken);
};

export const getRefreshToken = (): string | null => {
  const refreshToken = ELSStorageHelper.driver(ELSCommonUIConstants.security.Locker.DefaultDriver)
    .namespace(ELSCommonUIConstants.security.Locker.TokenNamespace)
    .get(refreshTokenKey);
  return refreshToken || null;
};

export const clearRefreshToken = (): void => {
  ELSStorageHelper.driver(ELSCommonUIConstants.security.Locker.DefaultDriver)
    .namespace(ELSCommonUIConstants.security.Locker.TokenNamespace)
    .remove(refreshTokenKey);
};
